import { Vector3 } from '@babylonjs/core';
import { ObstacleDistributionConfig } from '../ObstacleGenerator';
import { ObstacleBehavior } from './ObstacleBehavior';

export class ObstaclePatrolBehavior extends ObstacleBehavior {
  private angle: number = 0;
  constructor(startPosition: Vector3, pathIndex: number, config: ObstacleDistributionConfig) {
    super('obstaclePatrol', startPosition, pathIndex, config);
  }
  update(deltaTime: number): void {
    const angle = this.level.absoluteTime * this.config.speed;
    this.mesh.position.x = this.startPosition.x + Math.cos(angle) * this.config.radius;
    this.mesh.position.z = this.startPosition.z + Math.sin(angle) * this.config.radius;
  }
  clone(): ObstaclePatrolBehavior {
    return new ObstaclePatrolBehavior(this.startPosition, this.pathIndex, this.config);
  }
}
